export enum DirectorTrainingOrEducationType {
  None,
  BSc,
  MSc,
  PhD
}
